import styled, { css } from 'styled-components'
import Button from '../layout/Button'

export const Wysiwyg = styled.div<any>`
  h2 {
    margin-bottom: 1.75rem;
  }
  
  h3, h4, h5, h6 {
    margin-bottom: 1.25rem;
  }
  
  p {
    margin-bottom: 1.25rem;
  }
  
  a:not([class*="btn"], ${Button}) {
    display: inline-block;
    color: var(--black);
    font-weight: 600;
    line-height: 1;
    text-decoration: none;
    border-bottom: 2px solid var(--black);
    transition: border var(--transition-sm);
    
    &:hover, &:focus {
      border-bottom: 2px solid transparent;
    }
  }
  
  ol {
    margin: 1.5rem 0;
    padding-left: 2.5rem;
    li {
      padding-left: 0.25rem;
    }
  }
  
  ul {
    margin: 1.5rem 0;
    padding-left: 2.75rem;
    list-style: none;
    li {
      position: relative;
      &::before {
        content: '';
        display: block;
        position: absolute;
        left: -1.25rem;
        top: 0.625rem;
        height: 0.25rem;
        width: 0.25rem;
        background: var(--black);
        border-radius: 100%;
      }
    }
  }
  
  li {
    font-size: var(--paragraph-font-size);
    margin-bottom: 0.5rem;
  }
  
  hr {
    border-bottom: 1px solid var(--grey-30);
    margin: 2rem 0;
  }

  blockquote {
    border-left: 0.25rem solid var(--secondary-color);
    padding-left: 1rem;
    margin: 1.5rem 1rem;
    font-size: 1.625rem;
    font-style: italic;
  }
  
  iframe {
    width: 100%;
    border: 0;
  }

  ${p => p.lastChildNoMargin && css`
    > *:last-child{
      margin-bottom: 0;
    }
  `}
`
